import React from "react";
import { Select, Button, Divider } from "antd";
import api from "../../services/api";

export default class AlterarOperador extends React.Component {
  state = {
    dados: {
      data: []
    },
    disabled: false
  };

  componentDidMount = async () => {
    const dados = await api.get("/change_owner/");
    this.setState({ dados: dados, disabled: false });
  };

  handleOnClick = async () => {
    this.setState({ ...this.state, disabled: true });
    const dados = {
      operador_1: this.state.operador_1,
      operador_2: this.state.operador_2
    };
    const res = await api.post("/change_owner/", dados);
    if (res.status == 200) {
      window.alert("Operador alterado com sucesso");
      await this.componentDidMount();
    } else {
      window.alert("Ocorreu um erro");
    }
  };

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            marginTop: "40px",
            borderStyle: "solid",
            borderColor: "#172842",
            borderRadius: "20px",
            width: "40%",
            marginLeft: "30%",
            padding: "20px",
            background: "white"
          }}
        >
          <b>Trocar Proprietário dos acordos</b>
          <br></br>
          <br></br>
          De:{" "}
          <Select
            style={{ width: "40%" }}
            onChange={e => {
              this.setState({ ...this.state, operador_1: e });
            }}
          >
            {this.state.dados.data.map(value => {
              return (
                <Select.Option value={value.operador}>
                  {value.operador__nome}
                </Select.Option>
              );
            })}
          </Select>
          <Divider type="vertical"></Divider>
          Para:{" "}
          <Select
            style={{ width: "40%" }}
            onChange={e => {
              this.setState({ ...this.state, operador_2: e });
            }}
          >
            {this.state.dados.data.map(value => {
              return (
                <Select.Option value={value.operador}>
                  {value.operador__nome}
                </Select.Option>
              );
            })}
          </Select>
          <Divider type="horizontal" />
          <Button
            type="primary"
            onClick={() => {
              this.handleOnClick();
            }}
            disabled={this.state.disabled}
          >
            Alterar
          </Button>
          {this.state.disabled ? "Alterando..." : ""}
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/alterar_operador.js